import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { ColumnData, SlideLayout } from '@gripp/shared-ui';
import { useCallback } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Activities as ActivitiesOld } from './activities-old';
import { ActivityFilters } from './activityFilters';
import { ActivityFoldOneColumn } from './activityFoldOneColumn';

export const Activities = () => {
  const isCropCircleEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  if (isCropCircleEnabled) {
    return <ActivitiesBase />;
  }

  return <ActivitiesOld />;
};

const ActivitiesBase = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { issueId } = useParams();
  const skipAutoSelect = (location.state as any)?.skipAutoSelect;

  const onIssueSelected = useCallback(
    (id: string) => {
      navigate(`/activities/${id}`);
    },
    [navigate]
  );

  const handleDataLoaded = useCallback(
    (data: any[]) => {
      if (data?.length > 0 && !issueId && !skipAutoSelect) {
        onIssueSelected(data[0].id);
      }
    },
    [issueId, onIssueSelected, skipAutoSelect]
  );

  const leftColumn: ColumnData = {
    title: 'activity.menu.title',
    mainComponent: (
      <ActivityFoldOneColumn
        onIssueSelected={onIssueSelected}
        showAssetName={true}
        selectedIssue={issueId}
        onDataLoaded={handleDataLoaded}
        hideFilterBar={true}
      />
    ),
    headerComponent: <ActivityFilters />,
    disableScroll: true,
  };

  return <SlideLayout leftColumn={leftColumn} enableChildRoutes />;
};
